<template>
  <div class="Registered">
    <p class="loginTitle">{{ title }}</p>
    <p class="loginDiscribe">{{ discribe }}</p>
    <div class="Registered-form">
      <div class="Registered-form-title">
        <div class="title-left">欢迎来到<br/>{{ title }}</div>
        <div class="title-center"></div>
        <div class="title-right">Register</div>
      </div>
      <report :reset="reset1" />
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="机构注册" name="first">
          <institution :reset="reset1" />
        </el-tab-pane>
        <el-tab-pane label="举报注册" name="second">
          <report :reset="reset2" />
        </el-tab-pane>
      </el-tabs> -->
    </div>
  </div>
</template>

<script>
import Institution from "./Institution.vue";
import Report from "./Report1.vue";
export default {
  name: "Login",
  // vue 页面刷新
  inject: ["reload"],
  components: {
    Institution,
    Report,
  },
  data() {
    return {
      activeName: "first",
      reset1: false,
      reset2: false,
      title: "湘江私募基金管理服务平台",
      discribe:
        "创新服务模式，全周期一站式服务与省级、湘江新区专项扶持政策同步发力，让机构能享实惠，长足发展",
    };
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
      // this.title = tab.name == "first" ? "湘江私募基金管理服务平台" : "公众举报平台";
      this.title =
        tab.name == "first"
          ? "湘江私募基金管理服务平台"
          : "湘江私募基金管理服务平台";
    },
  },
  watch: {
    activeName(newValue, old) {
      if (newValue == "first") {
        this.reset1 = true;
        this.reset2 = false;
      } else {
        this.reset1 = false;
        this.reset2 = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 20px;
  font-weight: 600;
  padding: 25px;
}

.Registered {
  position: relative;
  &-form {
    width: 456px;
    // height: 512px;
    border-radius: 16px;
    box-shadow: 3px 5px 7px 4px rgba(0, 0, 0, 0.1);
    padding: 20px;
    position: absolute;
    right: 11.63vw;
    background: #ffffff;
    top: 33vh;
    margin-top: -250px;
    &-title {
      display: flex;
      align-items: center;
      margin-bottom: 11px;
      margin-top: 23px;
      justify-content: center;
      .title-left {
        font-size: 24px;
        font-family: AlibabaB;
        text-align: left;
        color: #191818;
        line-height: 33px;
      }
      .title-center {
        margin-left: 6px;
        width: 4px;
        height: 20px;
        background: #3099fc;
        border-radius: 3px;
      }
      .title-right {
        font-size: 18px;
        font-family: Alibaba;
        margin-left: 10px;
        text-align: left;
        color: #191818;
        line-height: 25px;
      }
    }
    /* top: 50%; */
    /* transform: translateY(-50%); */
    ::v-deep  .el-tabs__nav {
      transform: translateX(-50%) !important;
      left: 50%;
      color: #6c7885 !important;
    }
    ::v-deep  .el-tabs__active-bar {
      background-color: #3165ff !important;
      height: 4px;
      background: #008fff;
      border-radius: 3px;
    }
    ::v-deep  .el-tabs__nav .el-tabs__item {
      font-size: 16px;
      color: #6c7885;
    }
    ::v-deep  .el-tabs__item.is-active {
      color: #3165ff !important;
    }
    ::v-deep .el-tabs__nav-wrap::after {
      background-color: transparent;
    }
    ::v-deep .el-tabs__content {
      padding: 0 47px;
    }
  }
}
</style>
